import { render, staticRenderFns } from "./Lgx183908558784430080.vue?vue&type=template&id=ab00a0a2&"
import script from "./Lgx183908558784430080.vue?vue&type=script&lang=js&"
export * from "./Lgx183908558784430080.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports